// extracted by mini-css-extract-plugin
export default {"container":"AppHeader_container__XybU5","content":"AppHeader_content__fDXFh","divider":"AppHeader_divider__ThlVR","buttons":"AppHeader_buttons__DJWQ8"};